<template>
  <el-dialog
    :title="$t('chainSupplier.editSupplier')"
    :visible.sync="dialogVisible"
    width="80%"
    @close="handleClose"
  >
    <el-form :model="editChainSupplierInfo" :rules="rules" ref="form" label-width="150px">
      <el-form-item :label="$t('chainSupplier.supplierName')" prop="name">
        <el-input v-model="editChainSupplierInfo.name" :placeholder="$t('chainSupplier.supplierNamePlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplier.appId')" prop="appId">
        <el-input v-model="editChainSupplierInfo.appId" :placeholder="$t('chainSupplier.appIdPlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplier.appSecure')" prop="appSecure">
        <el-input v-model="editChainSupplierInfo.appSecure" :placeholder="$t('chainSupplier.appSecurePlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplier.mchId')" prop="mchId">
        <el-input v-model="editChainSupplierInfo.mchId" :placeholder="$t('chainSupplier.mchIdPlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplier.mchKey')" prop="mchKey">
        <el-input v-model="editChainSupplierInfo.mchKey" :placeholder="$t('chainSupplier.mchKeyPlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplier.url')" prop="url">
        <el-input v-model="editChainSupplierInfo.url" :placeholder="$t('chainSupplier.urlPlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplier.beanName')" prop="beanName">
        <el-input v-model="editChainSupplierInfo.beanName" :placeholder="$t('chainSupplier.beanNamePlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplier.suType')" prop="suType">
        <el-select v-model="editChainSupplierInfo.suType" style="width:100%">
          <el-option :value="1" :label="$t('chainSupplier.suType1')"></el-option>
          <el-option :value="2" :label="$t('chainSupplier.suType2')"></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplier.remark')" prop="remark">
        <el-input 
          type="textarea"
          v-model="editChainSupplierInfo.remark"
          :placeholder="$t('chainSupplier.remarkPlaceholder')"
        ></el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="editChainSupplier">{{$t('common.save')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateChainSupplier } from '@/api/admin/chainSupplier/chainSupplierApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditChainSupplier',
  data() {
    return {
      dialogVisible: false,
      editChainSupplierInfo: {
        csId: '',
        name: '',
        appId: '',
        appSecure: '',
        mchId: '',
        mchKey: '',
        url: '',
        remark: '',
        beanName: '',
        suType: 1,
        shopId: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('chainSupplier.supplierNameRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('chainSupplier.supplierNameMaxLength'), trigger: 'blur' }
        ],
        appId: [
          { required: true, message: this.$t('chainSupplier.appIdRequired'), trigger: 'blur' },
          { max: 500, message: this.$t('chainSupplier.appIdMaxLength'), trigger: 'blur' }
        ],
        appSecure: [
          { required: true, message: this.$t('chainSupplier.appSecureRequired'), trigger: 'blur' },
          { max: 500, message: this.$t('chainSupplier.appSecureMaxLength'), trigger: 'blur' }
        ],
        mchId: [
          { required: true, message: this.$t('chainSupplier.mchIdRequired'), trigger: 'blur' },
          { max: 32, message: this.$t('chainSupplier.mchIdMaxLength'), trigger: 'blur' }
        ],
        mchKey: [
          { required: true, message: this.$t('chainSupplier.mchKeyRequired'), trigger: 'blur' },
          { max: 128, message: this.$t('chainSupplier.mchKeyMaxLength'), trigger: 'blur' }
        ],
        url: [
          { required: true, message: this.$t('chainSupplier.urlRequired'), trigger: 'blur' },
          { max: 128, message: this.$t('chainSupplier.urlMaxLength'), trigger: 'blur' }
        ],
        beanName: [
          { required: true, message: this.$t('chainSupplier.beanNameRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('chainSupplier.beanNameMaxLength'), trigger: 'blur' }
        ],
        csId: [
          { required: true, message: this.$t('chainSupplier.supplierIdRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(chainSupplier) {
      this.dialogVisible = true
      this.editChainSupplierInfo = {
        ...chainSupplier,
        shopId: getShopId()
      }
    },
    editChainSupplier() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        
        updateChainSupplier(this.editChainSupplierInfo).then(response => {
          const res = response.data
          if (res.code === 0) {
            this.$message.success(this.$t('common.saveSuccess'))
            this.dialogVisible = false
            this.$emit('listChainSupplier')
          } else {
            this.$message.error(res.msg)
          }
        }).catch(error => {
          this.$message.error(error.message)
        })
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.el-input, .el-textarea {
  width: 100%;
}
</style>